import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

const VARIABLES = ['a', 'b', 'x', 'y']
const SIGNS = ['+', '-', '×']
const RANGE_DATA: RangeDataModel = {
  1: {
    totalTerms: 2,
    maxVariable: 1,
    minCoefficient: 1,
    maxCoefficient: 1,
    minInteger: 1,
    maxInteger: 9,
  },
  2: {
    totalTerms: 3,
    maxVariable: 3,
    minCoefficient: 1,
    maxCoefficient: 5,
    minInteger: 1,
    maxInteger: 9,
  },
  3: {
    totalTerms: 4,
    maxVariable: 3,
    minCoefficient: 1,
    maxCoefficient: 5,
    minInteger: 1,
    maxInteger: 9,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  totalTerms: number
  maxVariable: number
  minCoefficient: number
  maxCoefficient: number
  minInteger: number
  maxInteger: number
}

interface EquationPartsModel {
  integer: number | string
  variable?: string
  sign?: string
}

export enum TermsType {
  SIGN,
  INTEGER,
  COEFFICIENT,
  VARIABLE,
}

export interface ClickablePartsModel {
  data: string
  isClicked: boolean
  type: TermsType
}

/**
 * generates a algebraic equation
 * @param difficultyLevel difficulty level of the activity
 * @param taskHistory equations to excludes
 * @returns generated equation in parts and equation string
 */
export function generateEquationForClickVariable(
  difficultyLevel: number,
  taskHistory: string[],
): [ClickablePartsModel[], string] {
  const totalTerms = RANGE_DATA[difficultyLevel].totalTerms
  const totalAlgebraicTerms = getRandomInt(1, RANGE_DATA[difficultyLevel].maxVariable)
  const algebraicEquationParts: EquationPartsModel[] = []
  const nonAlgebraicEquationParts: EquationPartsModel[] = []
  // eslint-disable-next-line
  for (let i = 0; i < totalTerms - totalAlgebraicTerms; i++) {
    nonAlgebraicEquationParts[i] = {
      integer: getRandomInt(RANGE_DATA[difficultyLevel].minInteger, RANGE_DATA[difficultyLevel].maxInteger),
      sign: SIGNS[getRandomInt(0, SIGNS.length - 1)],
    }
  }
  // eslint-disable-next-line
  for (let i = 0; i < totalAlgebraicTerms; i++) {
    algebraicEquationParts[i] = {
      integer: getRandomInt(RANGE_DATA[difficultyLevel].minInteger, RANGE_DATA[difficultyLevel].maxInteger),
      variable: VARIABLES[getRandomInt(0, VARIABLES.length - 1)],
      sign: SIGNS[getRandomInt(0, SIGNS.length - 1)],
    }
  }
  const equationParts = [...nonAlgebraicEquationParts, ...algebraicEquationParts]
  equationParts[0].sign = undefined

  let equationString = ''
  equationParts.forEach((item) => {
    equationString += `${item.sign ? ` ${item.sign}` : ''} ${item.integer}${item.variable ? item.variable : ''}`
  })
  if (taskHistory.includes(equationString)) return generateEquationForClickVariable(difficultyLevel, taskHistory)

  const clickableParts: ClickablePartsModel[] = []
  equationParts.forEach(({ sign, integer, variable }) => {
    if (sign) {
      clickableParts[clickableParts.length] = { data: sign, isClicked: false, type: TermsType.SIGN }
    }

    if (!variable || integer > 1) {
      clickableParts[clickableParts.length] = {
        data: `${integer}`,
        isClicked: false,
        type: variable ? TermsType.COEFFICIENT : TermsType.INTEGER,
      }
    }

    if (variable) {
      clickableParts[clickableParts.length] = {
        data: `${variable}`,
        isClicked: false,
        type: TermsType.VARIABLE,
      }
    }
  })
  return [clickableParts, equationString]
}

/**
 * check user answer
 * @param equationParts equation parts and click status
 * @returns if the answer is right or wrong
 */
export function checkAnswer(equationParts: ClickablePartsModel[]): boolean {
  // eslint-disable-next-line
  for (let i = 0; i < equationParts.length; i++) {
    if (
      (equationParts[i].isClicked && equationParts[i].type !== TermsType.VARIABLE) ||
      (!equationParts[i].isClicked && equationParts[i].type === TermsType.VARIABLE)
    ) {
      return false
    }
  }
  return true
}
